// extracted by mini-css-extract-plugin
export default {"rubricItemHeading":"mark-item-module__rubricItemHeading--KJwTs","rubricItemSelect":"mark-item-module__rubricItemSelect--_XZRO","errorMessage":"mark-item-module__errorMessage--OYL2Z"};